import './Bioinformatic.css';
import React from 'react'
import { Navigate, Route, Routes } from "react-router-dom"
import Home from './home/Home';
import PipelinesRoutes from './pipelines/PipelinesRoutes';
import Persephone from './persephone/Persephone';
import DatabasesBioinformatic from './databasesBioinformatic/DatabasesBioinformatic';

export default function BioinformaticRoutes() {

  return (
    <React.Fragment>
      <div className='container-fluid overflow-x-hidden'>
        <Routes>
          <Route path="" element={ <Navigate to="home" /> }/>
          <Route path="home" element={<Home/>} />
          <Route path="/pipelines/*" element={<PipelinesRoutes/>} />
          <Route path="persephone" element={<Persephone/>} />
          <Route path="databasesBioinformatic" element={<DatabasesBioinformatic/>} />
          <Route path="persephone" element={<Persephone/>} />
        </Routes>
      </div>
    </React.Fragment>
  )
}
